<template>
  <el-dialog
    :model-value="modelValue"
    title="练习介绍"
    :width="600"
    custom-class="before_exam_dialog"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <div class="top_tab">
      <span>练习介绍</span>
      <close
        class="close_icon"
        @click="handleClose"
      />
    </div>
    <div class="content">
      <div class="examName">
        {{ examName }}
      </div>
      <div class="flex_table_box">
        <div class="info_item">
          <div>题目数：共{{ practiceNum || 0 }}题</div>
        </div>
        <div class="info_item">
          <div>考试限时：</div>
          <span>不限时间</span>
        </div>
        <div class="info_item">
          <div>练习次数：不限次数</div>
        </div>
        <div class="info_item">
          <div />
        </div>
      </div>
      <div class="tip_item">
        <span>每次练习都将覆盖上一次的练习记录，请知晓！</span>
      </div>
    </div>
    <template #footer>
      <el-button
        plain
        @click="handleClose"
      >
        取消
      </el-button>
      <el-button
        type="primary"
        :disabled="!supportAloneSales"
        @click="handleCallback"
      >
        开始练习
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { useUserStore } from '@/stores/user'
import { Close } from '@element-plus/icons-vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  examName: {
    type: String,
    default: ''
  },
  practiceNum: {
    type: [String, Number],
    default: ''
  },
  supportAloneSales: {
    type: Boolean,
    default: true
  }
})
const { getToken } = useUserStore()
const token = computed(() => getToken())
const router = useRouter()
const route = useRoute()

const emit = defineEmits(['close', 'callback'])
const handleClose = () => {
  emit('close', false)
}
const handleCallback = () => {
  if (!token.value) {
    router.push({
      path: '/login',
      query: {
        redirect: encodeURIComponent(route.fullPath)
      }
    })
    return
  }
  emit('callback')
}
</script>

<style scoped lang="scss">
.top_tab {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  top: 0;
  width: 100%;
  padding: 14px 24px;
  border-bottom: 1px solid #ebeef5;
  span {
    color: #333;
    font-size: 16px;
    cursor: pointer;
  }
  .active {
    color: #333333;
  }
  .close_icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}
.content {
  padding: 20px 25px;
  border-radius: 5px;
  .examName{
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
    background: linear-gradient(90deg, #3D7FFF 0%, rgba(61, 127, 255, 0.8) 100%);
    box-shadow: inset 0px -1px 0px #EBEEF5;
  }
}
.flex_table_box{
  display: flex;
  flex-wrap: wrap;
  .info_item {
    width: 50%;
    height: 66px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #EBEEF5;;
    color: #333;
    &:nth-child(n+1){
      border-top: 0;
    }
    &:nth-last-child(1){
      border-bottom-right-radius: 5px;
    }
    &:nth-last-child(2){
      border-bottom-left-radius: 5px;
    }
    &:nth-child(even){
      border-left: 0;
    }
    img {
      width: 24px;
      height: 24px;
    }
  }
}

.tip_item {
  margin-top: 14px;
  margin-bottom: 63px;
  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    display: inline-block;
  }
  span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ff9d00;
  }
}
</style>
